import React from "react";
import Navigation from "../components/Navigation";
import Hero from "../components/sections/Hero";
import About from "../components/sections/About";
import Problem from "../components/sections/Problem";
import Solution from "../components/sections/Solution";
import PreHeadline from "../components/sections/PreHeadline";
import Packages from "../components/sections/Packages";
import Difference from "../components/sections/Difference";
import HowItWorks from "../components/sections/HowItWorks";
import Testimonial from "../components/sections/Testimonial";
import FinalCTA from "../components/sections/FinalCTA";
import EnquiryForm from "../components/sections/EnquiryForm";
import Footer from "../components/sections/Footer";
export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen">
      <Navigation />
      <main>
        <Hero />
        <About />
        <Problem />
        <Solution />
        <PreHeadline />
        <Packages />
        <Difference />
        <HowItWorks />
        <Testimonial />
        <FinalCTA />
        <EnquiryForm />
      </main>
      <Footer />
    </div>
  );
}
